import { createReducer, on } from '@ngrx/store';
import { RequestAccessActions } from '../actions';
import { RequestAccessState } from '../request-access.state';

export const initialState: RequestAccessState = {
  countries: null,
  formData: null,
  status: null,
  uploadFile: null,
  fileData: null,
  validationStatus: null,
  loading: null,
  error: null,
  success: null,
};

export const RequestAccessReducer = createReducer(
  initialState,

  on(RequestAccessActions.loadCountries, (state) => {
    return {
      ...state,
      loading: true,
      success: null,
      error: null,
    };
  }),
  on(RequestAccessActions.loadCountriesSuccess, (state, { countries }) => {
    return {
      ...state,
      countries,
      loading: null,
      success: true,
      error: null,
    };
  }),

  on(RequestAccessActions.loadCountriesFail, (state, { payload }) => {
    return {
      ...state,
      loading: null,
      success: null,
      error: payload,
    };
  }),

  on(RequestAccessActions.submitForm, (state, { formData }) => {
    return { ...state, formData, loading: true, success: null, error: null };
  }),

  on(RequestAccessActions.submitFormSuccess, (state, { status }) => {
    return { ...state, status, loading: null, success: true, error: null };
  }),

  on(RequestAccessActions.submitFormFail, (state, { payload }) => {
    return {
      ...state,
      loading: null,
      success: null,
      error: payload,
    };
  }),

  on(RequestAccessActions.fileType, (state, { fileData }) => {
    return {
      ...state,
      fileData,
    };
  }),

  on(RequestAccessActions.resetResponse, (state) => {
    return {
      ...state,
      status: false,
    };
  }),

  on(RequestAccessActions.captchaValidation, (state, { validationStatus }) => {
    return {
      ...state,
      validationStatus,
    };
  })
);
